import { createApp } from 'vue'
import App from './app.vue'

import router from '@router'
import store from '@state/store'

import popup from '@utils/popup.js'
import $ from '@utils/axios.js'

import axios from 'axios'
import { createHead } from '@vueuse/head'

// Globally register all `_base`-prefixed components
import  { registerGlobalComponents } from '@components/_globals'

const app = createApp(App)
const head = createHead()


registerGlobalComponents(app)

app.config.globalProperties.$popup = popup
app.config.globalProperties.$axios = $
if (process.env.VUE_APP_API_HOST) {
  app.config.globalProperties.$axios.defaults.baseURL = process.env.VUE_APP_API_HOST
}

app.config.globalProperties.$http = axios
if (process.env.VUE_APP_API_HOST) {
  app.config.globalProperties.$http.defaults.baseURL = process.env.VUE_APP_API_HOST
}

// Don't warn about using the dev version of Vue in development.
//app.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  app.config.errorHandler = window.Cypress.cy.onUncaughtException
}

app.use(router)
app.use(store)
app.use(head)
app.mount('#app')
/*
const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
*/
// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}

store.dispatch('env/fetchMapboxToken')
